import { get, post, patch, httpDelete, pagedFetch } from '../httpHelpers/primer';
import { BusinessUnit, Consortium, DBMuleCentre } from '@cambridgeassessment/lib-ee-commons';
import * as primerSAPI from '../httpHelpers/primer';

export const fetchCentre = async (businessUnitId: string, centreId: string): Promise<DBMuleCentre | null> =>
  primerSAPI.get(`v1/centres/${centreId}?businessUnitId=${businessUnitId}`);

export const fetchConsortia = (
  businessUnitId: BusinessUnit['id'],
  series: string,
  searchValue?: string,
  nextUrl?: string,
): Promise<{ results: Consortium[]; nextUrl?: string }> => {
  const url = `v1/businessUnit/${businessUnitId}/consortia?series=${series}`;
  const searchParams = searchValue ? `&searchValue=${searchValue}` : '';

  return pagedFetch(url + searchParams, nextUrl);
};

export const fetchConsortium = (id: string): Promise<Consortium> => get(`v1/id/consortia/${id}`);

export const createConsortium = (businessUnitId: BusinessUnit['id'], consortium: Consortium): Promise<Consortium> =>
  post(`v1/businessUnit/${businessUnitId}/consortia`, consortium);

export const upsertConsortium = (id: string, consortium: Consortium): Promise<Consortium> =>
  patch(`v1/id/consortia/${id}`, consortium);

export const validateConsortium = (
  businessUnitId: BusinessUnit['id'],
  consortium: Consortium,
): Promise<{ isNameUnique: boolean; isConsortiumUnique: boolean }> =>
  post(`v1/businessUnit/${businessUnitId}/consortia/validate`, consortium);

export const deleteConsortium = (id: string): Promise<void> => httpDelete(`v1/id/consortia/${id}`);
